'use strict';
const BufferReader = require("./buffer-reader").HexBufferReaderWrapper;
const factory = require("./parsers/ucp-parser-factory");

// deviceType get from sn
function parseToJson(payload = "", deviceType = "DIGIT", ucpVersion = "v1.1", payloadType = "hex", mode = "cloud") {
    let res = {error: null, data: []};
    try {
        payload = payload.replace(/\s/g, '');
        let buffer = Buffer.from(payload, payloadType);
        let readers = separatePackages(buffer, mode);
        res.data = readers.map(reader => handle(reader, deviceType, ucpVersion, mode));
    } catch (e) {
        res.error = e.message;
    }
    return res;
}

function handle(reader, deviceType, ucpVersion, mode) {
    let res = {error: null, raw: reader.toString(), data: null, table: {tableHead: [], tableRows: []}};
    try {
        parseUcpPackage(reader, deviceType, ucpVersion, mode);
    } catch (e) {
        console.error(e);
        res.error = e.message;
    }
    if (reader) {
        res.data = reader.result.data[0];
        res.table = reader.result.getTable();
        // console.log(JSON.stringify(res.table, null, 2));
    }
    return res;
}

function parseUcpPackage(reader, deviceType, ucpVersion, mode) {
    if (mode !== "ipso") {
        readAndValidateUcpHead(reader);
        let parser = factory.getParser(ucpVersion, deviceType, reader.result.get("type"), mode);
        parser.parse(reader);
        readAndValidateUcpEnd(reader);
    } else {
        let parser = factory.getParser(ucpVersion, deviceType, "*", mode);
        parser.parse(reader);
    }
}

function readAndValidateUcpHead(reader) {
    let start = reader.readUInt8("start", () => "START");
    if (start !== PACKAGE_FLAG.START) {
        reader.result.set("start", "unknown");
        throw new Error("payload is not start with 0x7E");
    }

    reader.readUInt8("type", value => PACKAGE_TYPE[value] || "unknown");
    if (reader.result.get("type") === "unknown") {
        throw new Error("unknown package type");
    }

    let length = reader.readUInt16LE("length");
    if (length !== reader.getLength()) {
        throw new Error("length error");
    }
}

function readAndValidateUcpEnd(reader) {
    let end = reader.readUInt8("end", () => "END");
    if (end !== PACKAGE_FLAG.END) {
        reader.result.set("end", "unknown");
        throw new Error("payload is not end with 0x7E");
    }
}

function separatePackages(buffer, mode) {
    let bufferReaders = [];
    if (mode !== "ipso") {
        while (buffer.length >= 5) {
            let start = buffer.readUInt8(0);
            if (start !== 0x7e) break;
            let length = buffer.readUInt16LE(2);
            if (length > buffer.length || length === 0) break;
            let end = buffer.readUInt8(length - 1);
            if (end !== 0x7e) break;
            bufferReaders.push(new BufferReader(buffer.slice(0, length)));
            buffer = buffer.slice(length);
        }
    }
    if (buffer.length > 0) {
        bufferReaders.push(new BufferReader(buffer));
    }
    return bufferReaders;
}

const PACKAGE_TYPE = {
    // 0xF1: 'COMMON',
    0xF2: 'CHANGE',
    0xF3: 'ATTRIBUTE',
    0xF4: 'REGULAR',
    0xF5: 'PARAMS',
    0xF6: 'DTU',
    0xF7: 'ALARM',
    0xF8: 'INTELLIGENCE',

    0x02: 'RESTART',
    0x05: 'RULE'
};

const PACKAGE_FLAG = {
    START: 0x7E,
    END: 0x7E
};

module.exports.parseToJson = parseToJson;



// WEBPACK FOOTER //
// ./src/lib/ucp/converter.js